import { useQuery } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth.ts';
import { apiFetch } from 'utils/apiUtils.ts';
import { TemplatesResponse } from 'queries/fetch/fetchCampaignTemplatesForTeam.ts';
import featureFlags from 'services/featureFlags.ts';
import { CampaignTemplate } from 'schemas/CampaignTemplates.schema.ts';

interface IFetchCampaignTemplateVariables {
  teamId: string;
  templateId: string|null;
}

export default function useFetchLatestTemplateDetails({ teamId, templateId }: IFetchCampaignTemplateVariables) {
  const { tokens } = useAuth();
  return useQuery({
    queryKey: ['lastestTemplateDetails', { teamId, templateId }],
    queryFn: async () => {
      const allTemplatesForTeam = await apiFetch<TemplatesResponse>({
        path: `team/${teamId}/templates`,
        method: 'GET',
        accessToken: String(tokens.accessToken),
      });

      return Object.fromEntries(
        allTemplatesForTeam.templates.find((template) => template.id === templateId)?.properties.map((property) => [property.key, property.value]) ?? [],
      ) as CampaignTemplate;
    },
    enabled: featureFlags.campaignTemplates,
  });
}
